import { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "What phonetic alphabets are supported?",
      answer: "PhoneticPro supports multiple phonetic systems including NATO/ICAO alphabet, International Phonetic Alphabet (IPA), and regional variations like German, French, and Spanish phonetic alphabets.",
    },
    {
      question: "Is my data secure?",
      answer: "Absolutely! All text conversion happens locally on your device. No data is ever sent to external servers. Your privacy is our top priority.",
    },
    {
      question: "Does it work offline?",
      answer: "Yes! Once installed, PhoneticPro works completely offline. No internet connection required for text conversion.",
    },
    {
      question: "What's the difference between Free and Pro?",
      answer: "Free includes all phonetic alphabets, real-time conversion, and theme customization. Pro adds batch conversion, PDF/Word export, custom pronunciation guides, multilingual support, and priority support.",
    },
    {
      question: "Is the Lifetime Deal really forever?",
      answer: "Yes! The LTD is a one-time payment of $14.99 that gives you lifetime access to all Pro features, including all future updates and new features we add.",
    },
    {
      question: "Can I use it for professional work?",
      answer: "Definitely! PhoneticPro is used by call center agents, pilots, dispatchers, language teachers, and professionals who need clear phonetic communication daily.",
    },
    {
      question: "Which browsers are supported?",
      answer: "PhoneticPro is available for Chrome and all Chromium-based browsers (Edge, Brave, Opera). Firefox and Safari versions are coming soon.",
    },
    {
      question: "How do I get support?",
      answer: "Free users get community support. Pro and LTD users get priority email support with response within 24 hours. LTD users also get VIP Discord access.",
    },
  ];

  return (
    <section id="faq" className="py-24 px-6 bg-muted/30">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
            <HelpCircle className="w-6 h-6 text-primary" />
          </div>
          <h2 className="text-3xl font-semibold mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground">
            Everything you need to know about PhoneticPro
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg border border-border bg-card overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-muted/50 transition-colors"
              >
                <span className="font-medium text-sm">{faq.question}</span>
                <ChevronDown 
                  className={cn(
                    "w-4 h-4 text-muted-foreground transition-transform",
                    openIndex === index && "rotate-180"
                  )} 
                />
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 text-sm text-muted-foreground leading-relaxed animate-fade-in">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <p className="text-center mt-8 text-sm text-muted-foreground">
          Still have questions?{' '}
          <a 
            href="mailto:support@cemates.me" 
            className="text-foreground hover:underline underline-offset-4"
          >
            Contact us
          </a>
        </p>
      </div>
    </section>
  );
};

export default FAQ;